import { render, staticRenderFns } from "./DashboardServicosVisaoServicos.vue?vue&type=template&id=6e06e2fc&"
import script from "./DashboardServicosVisaoServicos.vue?vue&type=script&lang=js&"
export * from "./DashboardServicosVisaoServicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports